export function enumLabel(value: string): string {
  return value.split('/').map((part) => labelPart(part.trim())).join(' / ');
}

function labelPart(value: string): string {
  if (!value) return value;
  if (/^[A-Z0-9]{2,5}$/.test(value)) return value;
  const words = value.replace(/_/g, ' ').split(/\s+/).filter(Boolean);
  if (!words.length) return value;
  const [first, ...rest] = words;
  return [first.charAt(0).toUpperCase() + first.slice(1).toLowerCase(), ...rest.map((word) => word.toLowerCase())].join(' ');
}
